import React, { useState } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import "./App.css";
import Header from './components/Header';
import LanguageRouter from './components/LanguageRouter';
import { useLocalizedPath } from './hooks/useLocalizedPath';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import { useRTL } from './hooks/useRTL';
import Sidebar from './components/Sidebar';
import ExpressConverter from './components/ExpressConverter';
import UnitFinder from './components/UnitFinder';
import CommonConversions from './components/CommonConversions';
import FullConverters from './components/FullConverters';
import Footer from './components/Footer';
import ConverterPage from './components/ConverterPage';
import PlaceholderPage from './components/PlaceholderPage';
import CommonUnitSystemsPage from './components/CommonUnitSystemsPage';
import TermsOfUsePage from './components/TermsOfUsePage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import LengthConverterIndex from './components/LengthConverterIndex';
import UnitConversionPage from './components/UnitConversionPage';
import WeightConverterIndex from './components/WeightConverterIndex';
import WeightConversionPage from './components/WeightConversionPage';
import TemperatureConverterIndex from './components/TemperatureConverterIndex';
import TemperatureConversionPage from './components/TemperatureConversionPage';
import AreaConverterIndex from './components/AreaConverterIndex';
import AreaConversionPage from './components/AreaConversionPage';
import VolumeConverterIndex from './components/VolumeConverterIndex';
import VolumeConversionPage from './components/VolumeConversionPage';
import TimeConverterIndex from './components/TimeConverterIndex';
import TimeConversionPage from './components/TimeConversionPage';
import SpeedConverterIndex from './components/SpeedConverterIndex';
import SpeedConversionPage from './components/SpeedConversionPage';
import DataStorageConverterIndex from './components/DataStorageConverterIndex';
import DataStorageConversionPage from './components/DataStorageConversionPage';
import PressureConverterIndex from './components/PressureConverterIndex';
import PressureConversionPage from './components/PressureConversionPage';
import EnergyConverterIndex from './components/EnergyConverterIndex';
import EnergyConversionPage from './components/EnergyConversionPage';
import PowerConverterIndex from './components/PowerConverterIndex';
import PowerConversionPage from './components/PowerConversionPage';
import ForceConverterIndex from './components/ForceConverterIndex';
import ForceConversionPage from './components/ForceConversionPage';
import AngleConverterIndex from './components/AngleConverterIndex';
import AngleConversionPage from './components/AngleConversionPage';
import FrequencyConverterIndex from './components/FrequencyConverterIndex';
import FrequencyConversionPage from './components/FrequencyConversionPage';
import AccelerationConverterIndex from './components/AccelerationConverterIndex';
import AccelerationConversionPage from './components/AccelerationConversionPage';
import DensityConverterIndex from './components/DensityConverterIndex';
import DensityConversionPage from './components/DensityConversionPage';
import TorqueConverterIndex from './components/TorqueConverterIndex';
import TorqueConversionPage from './components/TorqueConversionPage';
import VelocityAngularConverterIndex from './components/VelocityAngularConverterIndex';
import VelocityAngularConversionPage from './components/VelocityAngularConversionPage';
import SpecificVolumeConverterIndex from './components/SpecificVolumeConverterIndex';
import SpecificVolumeConversionPage from './components/SpecificVolumeConversionPage';
import MomentOfInertiaConverterIndex from './components/MomentOfInertiaConverterIndex';
import MomentOfInertiaConversionPage from './components/MomentOfInertiaConversionPage';
import AccelerationAngularConverterIndex from './components/AccelerationAngularConverterIndex';
import AccelerationAngularConversionPage from './components/AccelerationAngularConversionPage';
import FuelEfficiencyConverterIndex from './components/FuelEfficiencyConverterIndex';
import FuelEfficiencyConversionPage from './components/FuelEfficiencyConversionPage';
import ThermalConductivityConverterIndex from './components/ThermalConductivityConverterIndex';
import ThermalConductivityConversionPage from './components/ThermalConductivityConversionPage';
import SpecificHeatConverterIndex from './components/SpecificHeatConverterIndex';
import SpecificHeatConversionPage from './components/SpecificHeatConversionPage';
import HeatFluxConverterIndex from './components/HeatFluxConverterIndex';
import HeatFluxConversionPage from './components/HeatFluxConversionPage';
import FlowRateConverterIndex from './components/FlowRateConverterIndex';
import FlowRateConversionPage from './components/FlowRateConversionPage';
import ViscosityConverterIndex from './components/ViscosityConverterIndex';
import ViscosityConversionPage from './components/ViscosityConversionPage';
import LuminanceConverterIndex from './components/LuminanceConverterIndex';
import LuminanceConversionPage from './components/LuminanceConversionPage';
import IlluminationConverterIndex from './components/IlluminationConverterIndex';
import IlluminationConversionPage from './components/IlluminationConversionPage';
import LuminousIntensityConverterIndex from './components/LuminousIntensityConverterIndex';
import LuminousIntensityConversionPage from './components/LuminousIntensityConversionPage';
import DigitalImageResolutionConverterIndex from './components/DigitalImageResolutionConverterIndex';
import DigitalImageResolutionConversionPage from './components/DigitalImageResolutionConversionPage';
import FrequencyWavelengthConverterIndex from './components/FrequencyWavelengthConverterIndex';
import FrequencyWavelengthConversionPage from './components/FrequencyWavelengthConversionPage';
import ChargeConverterIndex from './components/ChargeConverterIndex';
import ChargeConversionPage from './components/ChargeConversionPage';
import CurrentConverterIndex from './components/CurrentConverterIndex';
import CurrentConversionPage from './components/CurrentConversionPage';
import ElectricResistanceConverterIndex from './components/ElectricResistanceConverterIndex';
import ElectricResistanceConversionPage from './components/ElectricResistanceConversionPage';
import ElectricConductanceConverterIndex from './components/ElectricConductanceConverterIndex';
import ElectricConductanceConversionPage from './components/ElectricConductanceConversionPage';
import CapacitanceConverterIndex from './components/CapacitanceConverterIndex';
import CapacitanceConversionPage from './components/CapacitanceConversionPage';
import InductanceConverterIndex from './components/InductanceConverterIndex';
import InductanceConversionPage from './components/InductanceConversionPage';
import ElectricPotentialConverterIndex from './components/ElectricPotentialConverterIndex';
import ElectricPotentialConversionPage from './components/ElectricPotentialConversionPage';
import LinearChargeDensityConverterIndex from './components/LinearChargeDensityConverterIndex';
import LinearChargeDensityConversionPage from './components/LinearChargeDensityConversionPage';
import SurfaceChargeDensityConverterIndex from './components/SurfaceChargeDensityConverterIndex';
import SurfaceChargeDensityConversionPage from './components/SurfaceChargeDensityConversionPage';
import VolumeChargeDensityConverterIndex from './components/VolumeChargeDensityConverterIndex';
import VolumeChargeDensityConversionPage from './components/VolumeChargeDensityConversionPage';
import LinearCurrentDensityConverterIndex from './components/LinearCurrentDensityConverterIndex';
import LinearCurrentDensityConversionPage from './components/LinearCurrentDensityConversionPage';
import SurfaceCurrentDensityConverterIndex from './components/SurfaceCurrentDensityConverterIndex';
import SurfaceCurrentDensityConversionPage from './components/SurfaceCurrentDensityConversionPage';
import ElectricFieldStrengthConverterIndex from './components/ElectricFieldStrengthConverterIndex';
import ElectricFieldStrengthConversionPage from './components/ElectricFieldStrengthConversionPage';
import ElectricResistivityConverterIndex from './components/ElectricResistivityConverterIndex';
import ElectricResistivityConversionPage from './components/ElectricResistivityConversionPage';
import ElectricConductivityConverterIndex from './components/ElectricConductivityConverterIndex';
import ElectricConductivityConversionPage from './components/ElectricConductivityConversionPage';
import MagneticFluxConverterIndex from './components/MagneticFluxConverterIndex';
import MagneticFluxConversionPage from './components/MagneticFluxConversionPage';
import MagneticFluxDensityConverterIndex from './components/MagneticFluxDensityConverterIndex';
import MagneticFluxDensityConversionPage from './components/MagneticFluxDensityConversionPage';
import MagneticFieldStrengthConverterIndex from './components/MagneticFieldStrengthConverterIndex';
import MagneticFieldStrengthConversionPage from './components/MagneticFieldStrengthConversionPage';
import MagnetomotiveForceConverterIndex from './components/MagnetomotiveForceConverterIndex';
import MagnetomotiveForceConversionPage from './components/MagnetomotiveForceConversionPage';
import RadiationConverterIndex from './components/RadiationConverterIndex';
import RadiationConversionPage from './components/RadiationConversionPage';
import RadiationActivityConverterIndex from './components/RadiationActivityConverterIndex';
import RadiationActivityConversionPage from './components/RadiationActivityConversionPage';
import RadiationExposureConverterIndex from './components/RadiationExposureConverterIndex';
import RadiationExposureConversionPage from './components/RadiationExposureConversionPage';
import RadiationAbsorbedDoseConverterIndex from './components/RadiationAbsorbedDoseConverterIndex';
import RadiationAbsorbedDoseConversionPage from './components/RadiationAbsorbedDoseConversionPage';
import HeatFluxDensityConverterIndex from './components/HeatFluxDensityConverterIndex';
import HeatFluxDensityConversionPage from './components/HeatFluxDensityConversionPage';
import PrefixesConverterIndex from './components/PrefixesConverterIndex';
import PrefixesConversionPage from './components/PrefixesConversionPage';
import DataTransferConverterIndex from './components/DataTransferConverterIndex';
import DataTransferConversionPage from './components/DataTransferConversionPage';
import SoundConverterIndex from './components/SoundConverterIndex';
import SoundConversionPage from './components/SoundConversionPage';
import TypographyConverterIndex from './components/TypographyConverterIndex';
import TypographyConversionPage from './components/TypographyConversionPage';
import VolumeLumberConverterIndex from './components/VolumeLumberConverterIndex';
import VolumeLumberConversionPage from './components/VolumeLumberConversionPage';
import VolumeDryConverterIndex from './components/VolumeDryConverterIndex';
import VolumeDryConversionPage from './components/VolumeDryConversionPage';
import CurrencyConverterIndex from './components/CurrencyConverterIndex';
import CurrencyConversionPage from './components/CurrencyConversionPage';
import CaseConverterIndex from './components/CaseConverterIndex';
import FuelConsumptionConverterIndex from './components/FuelConsumptionConverterIndex';
import FuelConsumptionConversionPage from './components/FuelConsumptionConversionPage';
import NumbersConverterIndex from './components/NumbersConverterIndex';
import MomentForceConverterIndex from './components/MomentForceConverterIndex';
import MomentForceConversionPage from './components/MomentForceConversionPage';
import FuelEfficiencyMassConverterIndex from './components/FuelEfficiencyMassConverterIndex';
import FuelEfficiencyMassConversionPage from './components/FuelEfficiencyMassConversionPage';
import FuelEfficiencyVolumeConverterIndex from './components/FuelEfficiencyVolumeConverterIndex';
import FuelEfficiencyVolumeConversionPage from './components/FuelEfficiencyVolumeConversionPage';
import TemperatureIntervalConverterIndex from './components/TemperatureIntervalConverterIndex';
import TemperatureIntervalConversionPage from './components/TemperatureIntervalConversionPage';
import ThermalExpansionConverterIndex from './components/ThermalExpansionConverterIndex';
import ThermalExpansionConversionPage from './components/ThermalExpansionConversionPage';
import ThermalResistanceConverterIndex from './components/ThermalResistanceConverterIndex';
import ThermalResistanceConversionPage from './components/ThermalResistanceConversionPage';
import SpecificHeatCapacityConverterIndex from './components/SpecificHeatCapacityConverterIndex';
import SpecificHeatCapacityConversionPage from './components/SpecificHeatCapacityConversionPage';
import HeatDensityConverterIndex from './components/HeatDensityConverterIndex';
import HeatDensityConversionPage from './components/HeatDensityConversionPage';
import HeatTransferCoefficientConverterIndex from './components/HeatTransferCoefficientConverterIndex';
import HeatTransferCoefficientConversionPage from './components/HeatTransferCoefficientConversionPage';
import FlowMassConverterIndex from './components/FlowMassConverterIndex';
import FlowMassConversionPage from './components/FlowMassConversionPage';
import ConcentrationSolutionConverterIndex from './components/ConcentrationSolutionConverterIndex';
import ConcentrationSolutionConversionPage from './components/ConcentrationSolutionConversionPage';
import FlowMolarConverterIndex from './components/FlowMolarConverterIndex';
import FlowMolarConversionPage from './components/FlowMolarConversionPage';
import MassFluxDensityConverterIndex from './components/MassFluxDensityConverterIndex';
import MassFluxDensityConversionPage from './components/MassFluxDensityConversionPage';
import ConcentrationMolarConverterIndex from './components/ConcentrationMolarConverterIndex';
import ConcentrationMolarConversionPage from './components/ConcentrationMolarConversionPage';
import ViscosityKinematicConverterIndex from './components/ViscosityKinematicConverterIndex';
import ViscosityKinematicConversionPage from './components/ViscosityKinematicConversionPage';
import SurfaceTensionConverterIndex from './components/SurfaceTensionConverterIndex';
import SurfaceTensionConversionPage from './components/SurfaceTensionConversionPage';
import PermeabilityConverterIndex from './components/PermeabilityConverterIndex';
import PermeabilityConversionPage from './components/PermeabilityConversionPage';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const { getLocalizedPath } = useLocalizedPath();

  // Handle RTL languages (Arabic, Hebrew, etc.)
  const { isRTL } = useRTL();

  // Track page views in Google Analytics
  useGoogleAnalytics();

  const handleNavigate = (page, title = '') => {
    if (page === 'placeholder') {
      navigate(getLocalizedPath(`/page/${encodeURIComponent(title.toLowerCase().replace(/\s+/g, '-'))}`));
    } else {
      navigate(getLocalizedPath('/'));
    }
  };

  const handleSelectConverter = (category, converterId) => {
    // Map of converter IDs to paths
    const converterPaths = {
      'length': '/convert/length',
      'weight': '/convert/weight',
      'temperature': '/convert/temperature',
      'area': '/convert/area',
      'volume': '/convert/volume',
      'time': '/convert/time',
      'speed': '/convert/speed',
      'data-storage': '/convert/data-storage',
      'pressure': '/convert/pressure',
      'energy': '/convert/energy',
      'power': '/convert/power',
      'force': '/convert/force',
      'angle': '/convert/angle',
      'frequency': '/convert/frequency',
      'acceleration': '/convert/acceleration',
      'density': '/convert/density',
      'torque': '/convert/torque',
      'velocity-angular': '/convert/velocity-angular',
      'specific-volume': '/convert/specific-volume',
      'moment-of-inertia': '/convert/moment-of-inertia',
      'moment-inertia': '/convert/moment-of-inertia',
      'moment-force': '/convert/moment-force',
      'acceleration-angular': '/convert/acceleration-angular',
      'fuel-efficiency': '/convert/fuel-efficiency',
      'fuel-consumption': '/convert/fuel-consumption',
      'thermal-conductivity': '/convert/thermal-conductivity',
      'specific-heat': '/convert/specific-heat',
      'heat-flux': '/convert/heat-flux',
      'flow-rate': '/convert/flow-rate',
      'flow': '/convert/flow-rate',
      'flow-mass': '/convert/flow-mass',
      'concentration-solution': '/convert/concentration-solution',
      'flow-molar': '/convert/flow-molar',
      'mass-flux-density': '/convert/mass-flux-density',
      'concentration-molar': '/convert/concentration-molar',
      'viscosity': '/convert/viscosity',
      'viscosity-dynamic': '/convert/viscosity',
      'viscosity-kinematic': '/convert/viscosity-kinematic',
      'surface-tension': '/convert/surface-tension',
      'permeability': '/convert/permeability',
      'luminance': '/convert/luminance',
      'illumination': '/convert/illumination',
      'luminous-intensity': '/convert/luminous-intensity',
      'digital-image-resolution': '/convert/digital-image-resolution',
      'frequency-wavelength': '/convert/frequency-wavelength',
      'charge': '/convert/charge',
      'current': '/convert/current',
      'electric-resistance': '/convert/electric-resistance',
      'electric-conductance': '/convert/electric-conductance',
      'electrostatic-capacitance': '/convert/capacitance',
      'capacitance': '/convert/capacitance',
      'inductance': '/convert/inductance',
      'electric-potential': '/convert/electric-potential',
      'linear-charge-density': '/convert/linear-charge-density',
      'surface-charge-density': '/convert/surface-charge-density',
      'volume-charge-density': '/convert/volume-charge-density',
      'linear-current-density': '/convert/linear-current-density',
      'surface-current-density': '/convert/surface-current-density',
      'electric-field-strength': '/convert/electric-field-strength',
      'electric-resistivity': '/convert/electric-resistivity',
      'electric-conductivity': '/convert/electric-conductivity',
      'magnetic-flux': '/convert/magnetic-flux',
      'magnetic-flux-density': '/convert/magnetic-flux-density',
      'magnetic-field-strength': '/convert/magnetic-field-strength',
      'magnetomotive-force': '/convert/magnetomotive-force',
      'radiation': '/convert/radiation',
      'radiation-activity': '/convert/radiation-activity',
      'radiation-exposure': '/convert/radiation-exposure',
      'radiation-absorbed-dose': '/convert/radiation-absorbed-dose',
      'heat-flux-density': '/convert/heat-flux-density',
      'fuel-efficiency-mass': '/convert/fuel-efficiency-mass',
      'fuel-efficiency-volume': '/convert/fuel-efficiency-volume',
      'temperature-interval': '/convert/temperature-interval',
      'thermal-expansion': '/convert/thermal-expansion',
      'thermal-resistance': '/convert/thermal-resistance',
      'specific-heat-capacity': '/convert/specific-heat-capacity',
      'heat-density': '/convert/heat-density',
      'heat-transfer-coefficient': '/convert/heat-transfer-coefficient',
      'prefixes': '/convert/prefixes',
      'data-transfer': '/convert/data-transfer',
      'sound': '/convert/sound',
      'typography': '/convert/typography',
      'volume-lumber': '/convert/volume-lumber',
      'volume-dry': '/convert/volume-dry',
      'currency': '/convert/currency',
      'case': '/convert/case',
      'fuel': '/convert/fuel-consumption',
      'numbers': '/convert/numbers',
    };

    const path = converterPaths[converterId] || `/converter/${category}/${converterId}`;
    navigate(getLocalizedPath(path));
  };

  const handleBackToHome = () => {
    navigate(getLocalizedPath('/'));
  };

  const handleConversionSelect = (conversion) => {
    navigate(getLocalizedPath(`/converter/common/${conversion.category}`));
  };

  const handleUnitFinderConvert = (category, fromId, toId) => {
    navigate(getLocalizedPath(`/converter/common/${category}`));
  };

  // Home page content
  const HomePage = () => (
    <div className="space-y-6">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-800">Free Online Unit/Metric Converter</h1>
      <ExpressConverter />
      <UnitFinder onConvert={handleUnitFinderConvert} />
      <CommonConversions onSelectConversion={handleConversionSelect} />
      <FullConverters onSelectConverter={handleSelectConverter} />
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Header onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />

      <div className="flex flex-1">
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          onSelectConverter={handleSelectConverter}
        />

        <main className="flex-1 p-4 lg:p-6 max-w-5xl">
          <Routes>
            {/* English routes (no prefix) */}
            <Route element={<LanguageRouter />}>
              <Route path="/" element={<HomePage />} />
              <Route
                path="/converter/:category/:converterId"
                element={<ConverterPage onBack={handleBackToHome} />}
              />
              {/* Redirect old length converter URL to new one */}
              <Route
                path="/converter/common/length"
                element={<Navigate to="/convert/length" replace />}
              />
              <Route
                path="/convert/length"
                element={<LengthConverterIndex />}
              />
              <Route
                path="/convert/length/:conversion"
                element={<UnitConversionPage />}
              />
            {/* Weight converter routes */}
            <Route
              path="/converter/common/weight"
              element={<Navigate to="/convert/weight" replace />}
            />
            <Route
              path="/convert/weight"
              element={<WeightConverterIndex />}
            />
            <Route
              path="/convert/weight/:conversion"
              element={<WeightConversionPage />}
            />
            {/* Temperature converter routes */}
            <Route
              path="/converter/common/temperature"
              element={<Navigate to="/convert/temperature" replace />}
            />
            <Route
              path="/convert/temperature"
              element={<TemperatureConverterIndex />}
            />
            <Route
              path="/convert/temperature/:conversion"
              element={<TemperatureConversionPage />}
            />
            {/* Area converter routes */}
            <Route
              path="/converter/common/area"
              element={<Navigate to="/convert/area" replace />}
            />
            <Route
              path="/convert/area"
              element={<AreaConverterIndex />}
            />
            <Route
              path="/convert/area/:conversion"
              element={<AreaConversionPage />}
            />
            {/* Volume converter routes */}
            <Route
              path="/converter/common/volume"
              element={<Navigate to="/convert/volume" replace />}
            />
            <Route
              path="/convert/volume"
              element={<VolumeConverterIndex />}
            />
            <Route
              path="/convert/volume/:conversion"
              element={<VolumeConversionPage />}
            />
            {/* Time converter routes */}
            <Route
              path="/converter/common/time"
              element={<Navigate to="/convert/time" replace />}
            />
            <Route
              path="/convert/time"
              element={<TimeConverterIndex />}
            />
            <Route
              path="/convert/time/:conversion"
              element={<TimeConversionPage />}
            />
            {/* Speed converter routes */}
            <Route
              path="/converter/common/speed"
              element={<Navigate to="/convert/speed" replace />}
            />
            <Route
              path="/convert/speed"
              element={<SpeedConverterIndex />}
            />
            <Route
              path="/convert/speed/:conversion"
              element={<SpeedConversionPage />}
            />
            {/* Data Storage converter routes */}
            <Route
              path="/converter/common/data-storage"
              element={<Navigate to="/convert/data-storage" replace />}
            />
            <Route
              path="/convert/data-storage"
              element={<DataStorageConverterIndex />}
            />
            <Route
              path="/convert/data-storage/:conversion"
              element={<DataStorageConversionPage />}
            />
            {/* Pressure converter routes */}
            <Route
              path="/convert/pressure"
              element={<PressureConverterIndex />}
            />
            <Route
              path="/convert/pressure/:conversion"
              element={<PressureConversionPage />}
            />
            {/* Energy converter routes */}
            <Route
              path="/convert/energy"
              element={<EnergyConverterIndex />}
            />
            <Route
              path="/convert/energy/:conversion"
              element={<EnergyConversionPage />}
            />
            {/* Power converter routes */}
            <Route
              path="/convert/power"
              element={<PowerConverterIndex />}
            />
            <Route
              path="/convert/power/:conversion"
              element={<PowerConversionPage />}
            />
            {/* Force converter routes */}
            <Route
              path="/convert/force"
              element={<ForceConverterIndex />}
            />
            <Route
              path="/convert/force/:conversion"
              element={<ForceConversionPage />}
            />
            {/* Angle converter routes */}
            <Route
              path="/convert/angle"
              element={<AngleConverterIndex />}
            />
            <Route
              path="/convert/angle/:conversion"
              element={<AngleConversionPage />}
            />
            {/* Frequency converter routes */}
            <Route
              path="/convert/frequency"
              element={<FrequencyConverterIndex />}
            />
            <Route
              path="/convert/frequency/:conversion"
              element={<FrequencyConversionPage />}
            />
            {/* Acceleration converter routes */}
            <Route
              path="/convert/acceleration"
              element={<AccelerationConverterIndex />}
            />
            <Route
              path="/convert/acceleration/:conversion"
              element={<AccelerationConversionPage />}
            />
            {/* Density converter routes */}
            <Route
              path="/convert/density"
              element={<DensityConverterIndex />}
            />
            <Route
              path="/convert/density/:conversion"
              element={<DensityConversionPage />}
            />
            {/* Torque converter routes */}
            <Route
              path="/convert/torque"
              element={<TorqueConverterIndex />}
            />
            <Route
              path="/convert/torque/:conversion"
              element={<TorqueConversionPage />}
            />
            {/* Angular Velocity converter routes */}
            <Route
              path="/convert/velocity-angular"
              element={<VelocityAngularConverterIndex />}
            />
            <Route
              path="/convert/velocity-angular/:conversion"
              element={<VelocityAngularConversionPage />}
            />
            {/* Specific Volume converter routes */}
            <Route
              path="/convert/specific-volume"
              element={<SpecificVolumeConverterIndex />}
            />
            <Route
              path="/convert/specific-volume/:conversion"
              element={<SpecificVolumeConversionPage />}
            />
            {/* Moment of Inertia converter routes */}
            <Route
              path="/converter/engineering/moment-inertia"
              element={<Navigate to="/convert/moment-of-inertia" replace />}
            />
            <Route
              path="/convert/moment-of-inertia"
              element={<MomentOfInertiaConverterIndex />}
            />
            <Route
              path="/convert/moment-of-inertia/:conversion"
              element={<MomentOfInertiaConversionPage />}
            />
            {/* Moment of Force (Torque) converter routes */}
            <Route
              path="/converter/engineering/moment-force"
              element={<Navigate to="/convert/moment-force" replace />}
            />
            <Route
              path="/convert/moment-force"
              element={<MomentForceConverterIndex />}
            />
            <Route
              path="/convert/moment-force/:conversion"
              element={<MomentForceConversionPage />}
            />
            {/* Angular Acceleration converter routes */}
            <Route
              path="/convert/acceleration-angular"
              element={<AccelerationAngularConverterIndex />}
            />
            <Route
              path="/convert/acceleration-angular/:conversion"
              element={<AccelerationAngularConversionPage />}
            />
            {/* Fuel Efficiency converter routes */}
            <Route
              path="/convert/fuel-efficiency"
              element={<FuelEfficiencyConverterIndex />}
            />
            <Route
              path="/convert/fuel-efficiency/:conversion"
              element={<FuelEfficiencyConversionPage />}
            />
            {/* Thermal Conductivity converter routes */}
            <Route
              path="/convert/thermal-conductivity"
              element={<ThermalConductivityConverterIndex />}
            />
            <Route
              path="/convert/thermal-conductivity/:conversion"
              element={<ThermalConductivityConversionPage />}
            />
            {/* Specific Heat converter routes */}
            <Route
              path="/convert/specific-heat"
              element={<SpecificHeatConverterIndex />}
            />
            <Route
              path="/convert/specific-heat/:conversion"
              element={<SpecificHeatConversionPage />}
            />
            {/* Heat Flux converter routes */}
            <Route
              path="/convert/heat-flux"
              element={<HeatFluxConverterIndex />}
            />
            <Route
              path="/convert/heat-flux/:conversion"
              element={<HeatFluxConversionPage />}
            />
            {/* Flow Rate converter routes */}
            <Route
              path="/convert/flow-rate"
              element={<FlowRateConverterIndex />}
            />
            <Route
              path="/convert/flow-rate/:conversion"
              element={<FlowRateConversionPage />}
            />
            {/* Flow Mass converter routes */}
            <Route
              path="/convert/flow-mass"
              element={<FlowMassConverterIndex />}
            />
            <Route
              path="/convert/flow-mass/:conversion"
              element={<FlowMassConversionPage />}
            />
            {/* Concentration Solution converter routes */}
            <Route
              path="/converter/fluids/concentration-solution"
              element={<Navigate to="/convert/concentration-solution" replace />}
            />
            <Route
              path="/convert/concentration-solution"
              element={<ConcentrationSolutionConverterIndex />}
            />
            <Route
              path="/convert/concentration-solution/:conversion"
              element={<ConcentrationSolutionConversionPage />}
            />
            {/* Flow Molar converter routes */}
            <Route
              path="/converter/fluids/flow-molar"
              element={<Navigate to="/convert/flow-molar" replace />}
            />
            <Route
              path="/convert/flow-molar"
              element={<FlowMolarConverterIndex />}
            />
            <Route
              path="/convert/flow-molar/:conversion"
              element={<FlowMolarConversionPage />}
            />
            {/* Mass Flux Density converter routes */}
            <Route
              path="/converter/fluids/mass-flux-density"
              element={<Navigate to="/convert/mass-flux-density" replace />}
            />
            <Route
              path="/convert/mass-flux-density"
              element={<MassFluxDensityConverterIndex />}
            />
            <Route
              path="/convert/mass-flux-density/:conversion"
              element={<MassFluxDensityConversionPage />}
            />
            {/* Concentration Molar converter routes */}
            <Route
              path="/converter/fluids/concentration-molar"
              element={<Navigate to="/convert/concentration-molar" replace />}
            />
            <Route
              path="/convert/concentration-molar"
              element={<ConcentrationMolarConverterIndex />}
            />
            <Route
              path="/convert/concentration-molar/:conversion"
              element={<ConcentrationMolarConversionPage />}
            />
            {/* Viscosity Kinematic converter routes */}
            <Route
              path="/converter/fluids/viscosity-kinematic"
              element={<Navigate to="/convert/viscosity-kinematic" replace />}
            />
            <Route
              path="/convert/viscosity-kinematic"
              element={<ViscosityKinematicConverterIndex />}
            />
            <Route
              path="/convert/viscosity-kinematic/:conversion"
              element={<ViscosityKinematicConversionPage />}
            />
            {/* Surface Tension converter routes */}
            <Route
              path="/converter/fluids/surface-tension"
              element={<Navigate to="/convert/surface-tension" replace />}
            />
            <Route
              path="/convert/surface-tension"
              element={<SurfaceTensionConverterIndex />}
            />
            <Route
              path="/convert/surface-tension/:conversion"
              element={<SurfaceTensionConversionPage />}
            />
            {/* Permeability converter routes */}
            <Route
              path="/converter/fluids/permeability"
              element={<Navigate to="/convert/permeability" replace />}
            />
            <Route
              path="/convert/permeability"
              element={<PermeabilityConverterIndex />}
            />
            <Route
              path="/convert/permeability/:conversion"
              element={<PermeabilityConversionPage />}
            />
            {/* Viscosity converter routes */}
            <Route
              path="/convert/viscosity"
              element={<ViscosityConverterIndex />}
            />
            <Route
              path="/convert/viscosity/:conversion"
              element={<ViscosityConversionPage />}
            />
            {/* Luminance converter routes */}
            <Route
              path="/convert/luminance"
              element={<LuminanceConverterIndex />}
            />
            <Route
              path="/convert/luminance/:conversion"
              element={<LuminanceConversionPage />}
            />
            {/* Illumination converter routes */}
            <Route
              path="/convert/illumination"
              element={<IlluminationConverterIndex />}
            />
            <Route
              path="/convert/illumination/:conversion"
              element={<IlluminationConversionPage />}
            />
            {/* Luminous Intensity converter routes */}
            <Route
              path="/convert/luminous-intensity"
              element={<LuminousIntensityConverterIndex />}
            />
            <Route
              path="/convert/luminous-intensity/:conversion"
              element={<LuminousIntensityConversionPage />}
            />
            {/* Digital Image Resolution converter routes */}
            <Route
              path="/convert/digital-image-resolution"
              element={<DigitalImageResolutionConverterIndex />}
            />
            <Route
              path="/convert/digital-image-resolution/:conversion"
              element={<DigitalImageResolutionConversionPage />}
            />
            {/* Frequency Wavelength converter routes */}
            <Route
              path="/convert/frequency-wavelength"
              element={<FrequencyWavelengthConverterIndex />}
            />
            <Route
              path="/convert/frequency-wavelength/:conversion"
              element={<FrequencyWavelengthConversionPage />}
            />
            {/* Charge converter routes */}
            <Route
              path="/convert/charge"
              element={<ChargeConverterIndex />}
            />
            <Route
              path="/convert/charge/:conversion"
              element={<ChargeConversionPage />}
            />
            {/* Current converter routes */}
            <Route
              path="/convert/current"
              element={<CurrentConverterIndex />}
            />
            <Route
              path="/convert/current/:conversion"
              element={<CurrentConversionPage />}
            />
            {/* Electric Resistance converter routes */}
            <Route
              path="/convert/electric-resistance"
              element={<ElectricResistanceConverterIndex />}
            />
            <Route
              path="/convert/electric-resistance/:conversion"
              element={<ElectricResistanceConversionPage />}
            />
            {/* Electric Conductance converter routes */}
            <Route
              path="/convert/electric-conductance"
              element={<ElectricConductanceConverterIndex />}
            />
            <Route
              path="/convert/electric-conductance/:conversion"
              element={<ElectricConductanceConversionPage />}
            />
            {/* Capacitance converter routes */}
            <Route
              path="/convert/capacitance"
              element={<CapacitanceConverterIndex />}
            />
            <Route
              path="/convert/capacitance/:conversion"
              element={<CapacitanceConversionPage />}
            />
            {/* Inductance converter routes */}
            <Route
              path="/convert/inductance"
              element={<InductanceConverterIndex />}
            />
            <Route
              path="/convert/inductance/:conversion"
              element={<InductanceConversionPage />}
            />
            {/* Electric Potential converter routes */}
            <Route
              path="/convert/electric-potential"
              element={<ElectricPotentialConverterIndex />}
            />
            <Route
              path="/convert/electric-potential/:conversion"
              element={<ElectricPotentialConversionPage />}
            />
            {/* Linear Charge Density converter routes */}
            <Route
              path="/converter/electricity/linear-charge-density"
              element={<Navigate to="/convert/linear-charge-density" replace />}
            />
            <Route
              path="/convert/linear-charge-density"
              element={<LinearChargeDensityConverterIndex />}
            />
            <Route
              path="/convert/linear-charge-density/:conversion"
              element={<LinearChargeDensityConversionPage />}
            />
            {/* Surface Charge Density converter routes */}
            <Route
              path="/converter/electricity/surface-charge-density"
              element={<Navigate to="/convert/surface-charge-density" replace />}
            />
            <Route
              path="/convert/surface-charge-density"
              element={<SurfaceChargeDensityConverterIndex />}
            />
            <Route
              path="/convert/surface-charge-density/:conversion"
              element={<SurfaceChargeDensityConversionPage />}
            />
            {/* Volume Charge Density converter routes */}
            <Route
              path="/converter/electricity/volume-charge-density"
              element={<Navigate to="/convert/volume-charge-density" replace />}
            />
            <Route
              path="/convert/volume-charge-density"
              element={<VolumeChargeDensityConverterIndex />}
            />
            <Route
              path="/convert/volume-charge-density/:conversion"
              element={<VolumeChargeDensityConversionPage />}
            />
            {/* Linear Current Density converter routes */}
            <Route
              path="/converter/electricity/linear-current-density"
              element={<Navigate to="/convert/linear-current-density" replace />}
            />
            <Route
              path="/convert/linear-current-density"
              element={<LinearCurrentDensityConverterIndex />}
            />
            <Route
              path="/convert/linear-current-density/:conversion"
              element={<LinearCurrentDensityConversionPage />}
            />
            {/* Surface Current Density converter routes */}
            <Route
              path="/converter/electricity/surface-current-density"
              element={<Navigate to="/convert/surface-current-density" replace />}
            />
            <Route
              path="/convert/surface-current-density"
              element={<SurfaceCurrentDensityConverterIndex />}
            />
            <Route
              path="/convert/surface-current-density/:conversion"
              element={<SurfaceCurrentDensityConversionPage />}
            />
            {/* Electric Field Strength converter routes */}
            <Route
              path="/converter/electricity/electric-field-strength"
              element={<Navigate to="/convert/electric-field-strength" replace />}
            />
            <Route
              path="/convert/electric-field-strength"
              element={<ElectricFieldStrengthConverterIndex />}
            />
            <Route
              path="/convert/electric-field-strength/:conversion"
              element={<ElectricFieldStrengthConversionPage />}
            />
            {/* Electric Resistivity converter routes */}
            <Route
              path="/converter/electricity/electric-resistivity"
              element={<Navigate to="/convert/electric-resistivity" replace />}
            />
            <Route
              path="/convert/electric-resistivity"
              element={<ElectricResistivityConverterIndex />}
            />
            <Route
              path="/convert/electric-resistivity/:conversion"
              element={<ElectricResistivityConversionPage />}
            />
            {/* Electric Conductivity converter routes */}
            <Route
              path="/converter/electricity/electric-conductivity"
              element={<Navigate to="/convert/electric-conductivity" replace />}
            />
            <Route
              path="/convert/electric-conductivity"
              element={<ElectricConductivityConverterIndex />}
            />
            <Route
              path="/convert/electric-conductivity/:conversion"
              element={<ElectricConductivityConversionPage />}
            />
            {/* Magnetic Flux converter routes */}
            <Route
              path="/convert/magnetic-flux"
              element={<MagneticFluxConverterIndex />}
            />
            <Route
              path="/convert/magnetic-flux/:conversion"
              element={<MagneticFluxConversionPage />}
            />
            {/* Magnetic Flux Density converter routes */}
            <Route
              path="/convert/magnetic-flux-density"
              element={<MagneticFluxDensityConverterIndex />}
            />
            <Route
              path="/convert/magnetic-flux-density/:conversion"
              element={<MagneticFluxDensityConversionPage />}
            />
            {/* Magnetic Field Strength converter routes */}
            <Route
              path="/convert/magnetic-field-strength"
              element={<MagneticFieldStrengthConverterIndex />}
            />
            <Route
              path="/convert/magnetic-field-strength/:conversion"
              element={<MagneticFieldStrengthConversionPage />}
            />
            {/* Magnetomotive Force converter routes */}
            <Route
              path="/convert/magnetomotive-force"
              element={<MagnetomotiveForceConverterIndex />}
            />
            <Route
              path="/convert/magnetomotive-force/:conversion"
              element={<MagnetomotiveForceConversionPage />}
            />
            {/* Radiation converter routes */}
            <Route
              path="/convert/radiation"
              element={<RadiationConverterIndex />}
            />
            <Route
              path="/convert/radiation/:conversion"
              element={<RadiationConversionPage />}
            />
            {/* Radiation Activity converter routes */}
            <Route
              path="/convert/radiation-activity"
              element={<RadiationActivityConverterIndex />}
            />
            <Route
              path="/convert/radiation-activity/:conversion"
              element={<RadiationActivityConversionPage />}
            />
            {/* Radiation Exposure converter routes */}
            <Route
              path="/convert/radiation-exposure"
              element={<RadiationExposureConverterIndex />}
            />
            <Route
              path="/convert/radiation-exposure/:conversion"
              element={<RadiationExposureConversionPage />}
            />
            {/* Radiation Absorbed Dose converter routes */}
            <Route
              path="/convert/radiation-absorbed-dose"
              element={<RadiationAbsorbedDoseConverterIndex />}
            />
            <Route
              path="/convert/radiation-absorbed-dose/:conversion"
              element={<RadiationAbsorbedDoseConversionPage />}
            />
            {/* Heat Flux Density converter routes */}
            <Route
              path="/converter/heat/heat-flux-density"
              element={<Navigate to="/convert/heat-flux-density" replace />}
            />
            <Route
              path="/convert/heat-flux-density"
              element={<HeatFluxDensityConverterIndex />}
            />
            <Route
              path="/convert/heat-flux-density/:conversion"
              element={<HeatFluxDensityConversionPage />}
            />
            {/* Fuel Efficiency Mass converter routes */}
            <Route
              path="/converter/heat/fuel-efficiency-mass"
              element={<Navigate to="/convert/fuel-efficiency-mass" replace />}
            />
            <Route
              path="/convert/fuel-efficiency-mass"
              element={<FuelEfficiencyMassConverterIndex />}
            />
            <Route
              path="/convert/fuel-efficiency-mass/:conversion"
              element={<FuelEfficiencyMassConversionPage />}
            />
            {/* Fuel Efficiency Volume converter routes */}
            <Route
              path="/converter/heat/fuel-efficiency-volume"
              element={<Navigate to="/convert/fuel-efficiency-volume" replace />}
            />
            <Route
              path="/convert/fuel-efficiency-volume"
              element={<FuelEfficiencyVolumeConverterIndex />}
            />
            <Route
              path="/convert/fuel-efficiency-volume/:conversion"
              element={<FuelEfficiencyVolumeConversionPage />}
            />
            {/* Temperature Interval converter routes */}
            <Route
              path="/converter/heat/temperature-interval"
              element={<Navigate to="/convert/temperature-interval" replace />}
            />
            <Route
              path="/convert/temperature-interval"
              element={<TemperatureIntervalConverterIndex />}
            />
            <Route
              path="/convert/temperature-interval/:conversion"
              element={<TemperatureIntervalConversionPage />}
            />
            {/* Thermal Expansion converter routes */}
            <Route
              path="/converter/heat/thermal-expansion"
              element={<Navigate to="/convert/thermal-expansion" replace />}
            />
            <Route
              path="/convert/thermal-expansion"
              element={<ThermalExpansionConverterIndex />}
            />
            <Route
              path="/convert/thermal-expansion/:conversion"
              element={<ThermalExpansionConversionPage />}
            />
            {/* Thermal Resistance converter routes */}
            <Route
              path="/converter/heat/thermal-resistance"
              element={<Navigate to="/convert/thermal-resistance" replace />}
            />
            <Route
              path="/convert/thermal-resistance"
              element={<ThermalResistanceConverterIndex />}
            />
            <Route
              path="/convert/thermal-resistance/:conversion"
              element={<ThermalResistanceConversionPage />}
            />
            {/* Specific Heat Capacity converter routes */}
            <Route
              path="/converter/heat/specific-heat-capacity"
              element={<Navigate to="/convert/specific-heat-capacity" replace />}
            />
            <Route
              path="/convert/specific-heat-capacity"
              element={<SpecificHeatCapacityConverterIndex />}
            />
            <Route
              path="/convert/specific-heat-capacity/:conversion"
              element={<SpecificHeatCapacityConversionPage />}
            />
            {/* Heat Density converter routes */}
            <Route
              path="/converter/heat/heat-density"
              element={<Navigate to="/convert/heat-density" replace />}
            />
            <Route
              path="/convert/heat-density"
              element={<HeatDensityConverterIndex />}
            />
            <Route
              path="/convert/heat-density/:conversion"
              element={<HeatDensityConversionPage />}
            />
            {/* Heat Transfer Coefficient converter routes */}
            <Route
              path="/converter/heat/heat-transfer-coefficient"
              element={<Navigate to="/convert/heat-transfer-coefficient" replace />}
            />
            <Route
              path="/convert/heat-transfer-coefficient"
              element={<HeatTransferCoefficientConverterIndex />}
            />
            <Route
              path="/convert/heat-transfer-coefficient/:conversion"
              element={<HeatTransferCoefficientConversionPage />}
            />
            {/* SI Prefixes converter routes */}
            <Route
              path="/convert/prefixes"
              element={<PrefixesConverterIndex />}
            />
            <Route
              path="/convert/prefixes/:conversion"
              element={<PrefixesConversionPage />}
            />
            {/* Data Transfer converter routes */}
            <Route
              path="/convert/data-transfer"
              element={<DataTransferConverterIndex />}
            />
            <Route
              path="/convert/data-transfer/:conversion"
              element={<DataTransferConversionPage />}
            />
            {/* Sound converter routes */}
            <Route
              path="/convert/sound"
              element={<SoundConverterIndex />}
            />
            <Route
              path="/convert/sound/:conversion"
              element={<SoundConversionPage />}
            />
            {/* Typography converter routes */}
            <Route
              path="/convert/typography"
              element={<TypographyConverterIndex />}
            />
            <Route
              path="/convert/typography/:conversion"
              element={<TypographyConversionPage />}
            />
            {/* Volume Lumber converter routes */}
            <Route
              path="/convert/volume-lumber"
              element={<VolumeLumberConverterIndex />}
            />
            <Route
              path="/convert/volume-lumber/:conversion"
              element={<VolumeLumberConversionPage />}
            />
            {/* Volume Dry converter routes */}
            <Route
              path="/converter/common/volume-dry"
              element={<Navigate to="/convert/volume-dry" replace />}
            />
            <Route
              path="/convert/volume-dry"
              element={<VolumeDryConverterIndex />}
            />
            <Route
              path="/convert/volume-dry/:conversion"
              element={<VolumeDryConversionPage />}
            />
            {/* Currency converter routes */}
            <Route
              path="/converter/common/currency"
              element={<Navigate to="/convert/currency" replace />}
            />
            <Route
              path="/convert/currency"
              element={<CurrencyConverterIndex />}
            />
            <Route
              path="/convert/currency/:conversion"
              element={<CurrencyConversionPage />}
            />
            {/* Case converter routes */}
            <Route
              path="/converter/common/case"
              element={<Navigate to="/convert/case" replace />}
            />
            <Route
              path="/convert/case"
              element={<CaseConverterIndex />}
            />
            {/* Fuel Consumption converter routes */}
            <Route
              path="/converter/common/fuel"
              element={<Navigate to="/convert/fuel-consumption" replace />}
            />
            <Route
              path="/convert/fuel-consumption"
              element={<FuelConsumptionConverterIndex />}
            />
            <Route
              path="/convert/fuel-consumption/:conversion"
              element={<FuelConsumptionConversionPage />}
            />
            {/* Numbers converter routes */}
            <Route
              path="/converter/common/numbers"
              element={<Navigate to="/convert/numbers" replace />}
            />
            <Route
              path="/convert/numbers"
              element={<NumbersConverterIndex />}
            />
            <Route
              path="/page/common-unit-systems"
              element={<CommonUnitSystemsPage />}
            />
            <Route
              path="/page/terms-of-use"
              element={<TermsOfUsePage />}
            />
            <Route
              path="/page/privacy-policy"
              element={<PrivacyPolicyPage />}
            />
            <Route
              path="/page/:title"
              element={<PlaceholderPage onBack={handleBackToHome} />}
            />
            </Route>

            {/* Language-prefixed routes (es, de, fr, pt, hi, zh) */}
            <Route path="/:lang" element={<LanguageRouter />}>
              <Route index element={<HomePage />} />
              <Route
                path="converter/:category/:converterId"
                element={<ConverterPage onBack={handleBackToHome} />}
              />
              <Route path="convert/length" element={<LengthConverterIndex />} />
              <Route path="convert/length/:conversion" element={<UnitConversionPage />} />
              <Route path="convert/weight" element={<WeightConverterIndex />} />
              <Route path="convert/weight/:conversion" element={<WeightConversionPage />} />
              <Route path="convert/temperature" element={<TemperatureConverterIndex />} />
              <Route path="convert/temperature/:conversion" element={<TemperatureConversionPage />} />
              <Route path="convert/area" element={<AreaConverterIndex />} />
              <Route path="convert/area/:conversion" element={<AreaConversionPage />} />
              <Route path="convert/volume" element={<VolumeConverterIndex />} />
              <Route path="convert/volume/:conversion" element={<VolumeConversionPage />} />
              <Route path="convert/time" element={<TimeConverterIndex />} />
              <Route path="convert/time/:conversion" element={<TimeConversionPage />} />
              <Route path="convert/speed" element={<SpeedConverterIndex />} />
              <Route path="convert/speed/:conversion" element={<SpeedConversionPage />} />
              <Route path="convert/data-storage" element={<DataStorageConverterIndex />} />
              <Route path="convert/data-storage/:conversion" element={<DataStorageConversionPage />} />
              <Route path="convert/pressure" element={<PressureConverterIndex />} />
              <Route path="convert/pressure/:conversion" element={<PressureConversionPage />} />
              <Route path="convert/energy" element={<EnergyConverterIndex />} />
              <Route path="convert/energy/:conversion" element={<EnergyConversionPage />} />
              <Route path="convert/power" element={<PowerConverterIndex />} />
              <Route path="convert/power/:conversion" element={<PowerConversionPage />} />
              <Route path="convert/force" element={<ForceConverterIndex />} />
              <Route path="convert/force/:conversion" element={<ForceConversionPage />} />
              <Route path="convert/angle" element={<AngleConverterIndex />} />
              <Route path="convert/angle/:conversion" element={<AngleConversionPage />} />
              <Route path="convert/frequency" element={<FrequencyConverterIndex />} />
              <Route path="convert/frequency/:conversion" element={<FrequencyConversionPage />} />
              <Route path="convert/acceleration" element={<AccelerationConverterIndex />} />
              <Route path="convert/acceleration/:conversion" element={<AccelerationConversionPage />} />
              <Route path="convert/density" element={<DensityConverterIndex />} />
              <Route path="convert/density/:conversion" element={<DensityConversionPage />} />
              <Route path="convert/torque" element={<TorqueConverterIndex />} />
              <Route path="convert/torque/:conversion" element={<TorqueConversionPage />} />
              <Route path="convert/velocity-angular" element={<VelocityAngularConverterIndex />} />
              <Route path="convert/velocity-angular/:conversion" element={<VelocityAngularConversionPage />} />
              <Route path="convert/specific-volume" element={<SpecificVolumeConverterIndex />} />
              <Route path="convert/specific-volume/:conversion" element={<SpecificVolumeConversionPage />} />
              <Route path="convert/moment-of-inertia" element={<MomentOfInertiaConverterIndex />} />
              <Route path="convert/moment-of-inertia/:conversion" element={<MomentOfInertiaConversionPage />} />
              <Route path="convert/moment-force" element={<MomentForceConverterIndex />} />
              <Route path="convert/moment-force/:conversion" element={<MomentForceConversionPage />} />
              <Route path="convert/acceleration-angular" element={<AccelerationAngularConverterIndex />} />
              <Route path="convert/acceleration-angular/:conversion" element={<AccelerationAngularConversionPage />} />
              <Route path="convert/fuel-efficiency" element={<FuelEfficiencyConverterIndex />} />
              <Route path="convert/fuel-efficiency/:conversion" element={<FuelEfficiencyConversionPage />} />
              <Route path="convert/thermal-conductivity" element={<ThermalConductivityConverterIndex />} />
              <Route path="convert/thermal-conductivity/:conversion" element={<ThermalConductivityConversionPage />} />
              <Route path="convert/specific-heat" element={<SpecificHeatConverterIndex />} />
              <Route path="convert/specific-heat/:conversion" element={<SpecificHeatConversionPage />} />
              <Route path="convert/heat-flux" element={<HeatFluxConverterIndex />} />
              <Route path="convert/heat-flux/:conversion" element={<HeatFluxConversionPage />} />
              <Route path="convert/flow-rate" element={<FlowRateConverterIndex />} />
              <Route path="convert/flow-rate/:conversion" element={<FlowRateConversionPage />} />
              <Route path="convert/flow-mass" element={<FlowMassConverterIndex />} />
              <Route path="convert/flow-mass/:conversion" element={<FlowMassConversionPage />} />
              <Route path="convert/concentration-solution" element={<ConcentrationSolutionConverterIndex />} />
              <Route path="convert/concentration-solution/:conversion" element={<ConcentrationSolutionConversionPage />} />
              <Route path="convert/flow-molar" element={<FlowMolarConverterIndex />} />
              <Route path="convert/flow-molar/:conversion" element={<FlowMolarConversionPage />} />
              <Route path="convert/mass-flux-density" element={<MassFluxDensityConverterIndex />} />
              <Route path="convert/mass-flux-density/:conversion" element={<MassFluxDensityConversionPage />} />
              <Route path="convert/concentration-molar" element={<ConcentrationMolarConverterIndex />} />
              <Route path="convert/concentration-molar/:conversion" element={<ConcentrationMolarConversionPage />} />
              <Route path="convert/viscosity" element={<ViscosityConverterIndex />} />
              <Route path="convert/viscosity/:conversion" element={<ViscosityConversionPage />} />
              <Route path="convert/viscosity-kinematic" element={<ViscosityKinematicConverterIndex />} />
              <Route path="convert/viscosity-kinematic/:conversion" element={<ViscosityKinematicConversionPage />} />
              <Route path="convert/surface-tension" element={<SurfaceTensionConverterIndex />} />
              <Route path="convert/surface-tension/:conversion" element={<SurfaceTensionConversionPage />} />
              <Route path="convert/permeability" element={<PermeabilityConverterIndex />} />
              <Route path="convert/permeability/:conversion" element={<PermeabilityConversionPage />} />
              <Route path="convert/luminance" element={<LuminanceConverterIndex />} />
              <Route path="convert/luminance/:conversion" element={<LuminanceConversionPage />} />
              <Route path="convert/illumination" element={<IlluminationConverterIndex />} />
              <Route path="convert/illumination/:conversion" element={<IlluminationConversionPage />} />
              <Route path="convert/luminous-intensity" element={<LuminousIntensityConverterIndex />} />
              <Route path="convert/luminous-intensity/:conversion" element={<LuminousIntensityConversionPage />} />
              <Route path="convert/digital-image-resolution" element={<DigitalImageResolutionConverterIndex />} />
              <Route path="convert/digital-image-resolution/:conversion" element={<DigitalImageResolutionConversionPage />} />
              <Route path="convert/frequency-wavelength" element={<FrequencyWavelengthConverterIndex />} />
              <Route path="convert/frequency-wavelength/:conversion" element={<FrequencyWavelengthConversionPage />} />
              <Route path="convert/charge" element={<ChargeConverterIndex />} />
              <Route path="convert/charge/:conversion" element={<ChargeConversionPage />} />
              <Route path="convert/current" element={<CurrentConverterIndex />} />
              <Route path="convert/current/:conversion" element={<CurrentConversionPage />} />
              <Route path="convert/electric-resistance" element={<ElectricResistanceConverterIndex />} />
              <Route path="convert/electric-resistance/:conversion" element={<ElectricResistanceConversionPage />} />
              <Route path="convert/electric-conductance" element={<ElectricConductanceConverterIndex />} />
              <Route path="convert/electric-conductance/:conversion" element={<ElectricConductanceConversionPage />} />
              <Route path="convert/capacitance" element={<CapacitanceConverterIndex />} />
              <Route path="convert/capacitance/:conversion" element={<CapacitanceConversionPage />} />
              <Route path="convert/inductance" element={<InductanceConverterIndex />} />
              <Route path="convert/inductance/:conversion" element={<InductanceConversionPage />} />
              <Route path="convert/electric-potential" element={<ElectricPotentialConverterIndex />} />
              <Route path="convert/electric-potential/:conversion" element={<ElectricPotentialConversionPage />} />
              <Route path="convert/linear-charge-density" element={<LinearChargeDensityConverterIndex />} />
              <Route path="convert/linear-charge-density/:conversion" element={<LinearChargeDensityConversionPage />} />
              <Route path="convert/surface-charge-density" element={<SurfaceChargeDensityConverterIndex />} />
              <Route path="convert/surface-charge-density/:conversion" element={<SurfaceChargeDensityConversionPage />} />
              <Route path="convert/volume-charge-density" element={<VolumeChargeDensityConverterIndex />} />
              <Route path="convert/volume-charge-density/:conversion" element={<VolumeChargeDensityConversionPage />} />
              <Route path="convert/linear-current-density" element={<LinearCurrentDensityConverterIndex />} />
              <Route path="convert/linear-current-density/:conversion" element={<LinearCurrentDensityConversionPage />} />
              <Route path="convert/surface-current-density" element={<SurfaceCurrentDensityConverterIndex />} />
              <Route path="convert/surface-current-density/:conversion" element={<SurfaceCurrentDensityConversionPage />} />
              <Route path="convert/electric-field-strength" element={<ElectricFieldStrengthConverterIndex />} />
              <Route path="convert/electric-field-strength/:conversion" element={<ElectricFieldStrengthConversionPage />} />
              <Route path="convert/electric-resistivity" element={<ElectricResistivityConverterIndex />} />
              <Route path="convert/electric-resistivity/:conversion" element={<ElectricResistivityConversionPage />} />
              <Route path="convert/electric-conductivity" element={<ElectricConductivityConverterIndex />} />
              <Route path="convert/electric-conductivity/:conversion" element={<ElectricConductivityConversionPage />} />
              <Route path="convert/magnetic-flux" element={<MagneticFluxConverterIndex />} />
              <Route path="convert/magnetic-flux/:conversion" element={<MagneticFluxConversionPage />} />
              <Route path="convert/magnetic-flux-density" element={<MagneticFluxDensityConverterIndex />} />
              <Route path="convert/magnetic-flux-density/:conversion" element={<MagneticFluxDensityConversionPage />} />
              <Route path="convert/magnetic-field-strength" element={<MagneticFieldStrengthConverterIndex />} />
              <Route path="convert/magnetic-field-strength/:conversion" element={<MagneticFieldStrengthConversionPage />} />
              <Route path="convert/magnetomotive-force" element={<MagnetomotiveForceConverterIndex />} />
              <Route path="convert/magnetomotive-force/:conversion" element={<MagnetomotiveForceConversionPage />} />
              <Route path="convert/radiation" element={<RadiationConverterIndex />} />
              <Route path="convert/radiation/:conversion" element={<RadiationConversionPage />} />
              <Route path="convert/radiation-activity" element={<RadiationActivityConverterIndex />} />
              <Route path="convert/radiation-activity/:conversion" element={<RadiationActivityConversionPage />} />
              <Route path="convert/radiation-exposure" element={<RadiationExposureConverterIndex />} />
              <Route path="convert/radiation-exposure/:conversion" element={<RadiationExposureConversionPage />} />
              <Route path="convert/radiation-absorbed-dose" element={<RadiationAbsorbedDoseConverterIndex />} />
              <Route path="convert/radiation-absorbed-dose/:conversion" element={<RadiationAbsorbedDoseConversionPage />} />
              <Route path="convert/heat-flux-density" element={<HeatFluxDensityConverterIndex />} />
              <Route path="convert/heat-flux-density/:conversion" element={<HeatFluxDensityConversionPage />} />
              <Route path="convert/fuel-efficiency-mass" element={<FuelEfficiencyMassConverterIndex />} />
              <Route path="convert/fuel-efficiency-mass/:conversion" element={<FuelEfficiencyMassConversionPage />} />
              <Route path="convert/fuel-efficiency-volume" element={<FuelEfficiencyVolumeConverterIndex />} />
              <Route path="convert/fuel-efficiency-volume/:conversion" element={<FuelEfficiencyVolumeConversionPage />} />
              <Route path="convert/temperature-interval" element={<TemperatureIntervalConverterIndex />} />
              <Route path="convert/temperature-interval/:conversion" element={<TemperatureIntervalConversionPage />} />
              <Route path="convert/thermal-expansion" element={<ThermalExpansionConverterIndex />} />
              <Route path="convert/thermal-expansion/:conversion" element={<ThermalExpansionConversionPage />} />
              <Route path="convert/thermal-resistance" element={<ThermalResistanceConverterIndex />} />
              <Route path="convert/thermal-resistance/:conversion" element={<ThermalResistanceConversionPage />} />
              <Route path="convert/specific-heat-capacity" element={<SpecificHeatCapacityConverterIndex />} />
              <Route path="convert/specific-heat-capacity/:conversion" element={<SpecificHeatCapacityConversionPage />} />
              <Route path="convert/heat-density" element={<HeatDensityConverterIndex />} />
              <Route path="convert/heat-density/:conversion" element={<HeatDensityConversionPage />} />
              <Route path="convert/heat-transfer-coefficient" element={<HeatTransferCoefficientConverterIndex />} />
              <Route path="convert/heat-transfer-coefficient/:conversion" element={<HeatTransferCoefficientConversionPage />} />
              <Route path="convert/prefixes" element={<PrefixesConverterIndex />} />
              <Route path="convert/prefixes/:conversion" element={<PrefixesConversionPage />} />
              <Route path="convert/data-transfer" element={<DataTransferConverterIndex />} />
              <Route path="convert/data-transfer/:conversion" element={<DataTransferConversionPage />} />
              <Route path="convert/sound" element={<SoundConverterIndex />} />
              <Route path="convert/sound/:conversion" element={<SoundConversionPage />} />
              <Route path="convert/typography" element={<TypographyConverterIndex />} />
              <Route path="convert/typography/:conversion" element={<TypographyConversionPage />} />
              <Route path="convert/volume-lumber" element={<VolumeLumberConverterIndex />} />
              <Route path="convert/volume-lumber/:conversion" element={<VolumeLumberConversionPage />} />
              <Route path="convert/volume-dry" element={<VolumeDryConverterIndex />} />
              <Route path="convert/volume-dry/:conversion" element={<VolumeDryConversionPage />} />
              <Route path="convert/currency" element={<CurrencyConverterIndex />} />
              <Route path="convert/currency/:conversion" element={<CurrencyConversionPage />} />
              <Route path="convert/case" element={<CaseConverterIndex />} />
              <Route path="convert/fuel-consumption" element={<FuelConsumptionConverterIndex />} />
              <Route path="convert/fuel-consumption/:conversion" element={<FuelConsumptionConversionPage />} />
              <Route path="convert/numbers" element={<NumbersConverterIndex />} />
              <Route path="page/common-unit-systems" element={<CommonUnitSystemsPage />} />
              <Route path="page/terms-of-use" element={<TermsOfUsePage />} />
              <Route path="page/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="page/:title" element={<PlaceholderPage onBack={handleBackToHome} />} />
            </Route>
          </Routes>
        </main>
      </div>

      <Footer onNavigate={handleNavigate} />
    </div>
  );
}

export default App;
